import ProgressBar from "./ProgressBar";
import {formatDurationToHoursAndMinutes} from "../web/v1/functions";
import {cloneFromTemplate} from "../admin/images/functions";
export default class Episode {

    constructor(object, constants) {
        this.object = object;
        this.constants = constants;
    }

    element() {
        let template = cloneFromTemplate('#subseries_episode_template');
        this.clone = template.querySelector('.subseries-episode-clone');

        let link = this.clone.querySelector('a');
        link.id = 'episode-' + this.object['slug'] + '-s' + this.object['season_number'] + '-e' + this.object['episode_number'];;
        link.href = link.href.replace(':slug', this.object['slug']);

        let screenshot_container = link.querySelector('.episode-screenshot');
        let screenshot = this.screenshot();
        if ( screenshot_container && screenshot ) {
            screenshot_container.setAttribute('src',screenshot );
        }

        let name_container = link.querySelector('.episode-name');
        let name = this.name();
        if ( name_container &&  name ) {
            name_container.innerHTML = name;
        }

        let description_container = link.querySelector('.episode-description');
        let description = this.description();
        if ( description_container &&  description ) {
            description_container.innerHTML = description;
        }

        let progress_container = link.querySelector('.progress-duration');
        let progress = this.progress();
        if (progress_container && progress ) {
            progress_container.appendChild( progress );
        }

        let duration_container = this.clone.querySelector('.episode-duration');
        let duration = this.duration();
        if ( duration_container && duration ) {
            duration_container.innerHTML = duration;

            if ( this.displayExtras() ) {
                let constants = this.constants.text.modal.movie_details.tabs.episodes.extras;
                let additional_link_classes = ['btn', 'btn-outline-light', 'btn-sm', 'ml-2', 'align-middle', 'float-right'];
                if ( this.displayLesson() ) {
                    let lesson = this.extras_link(constants.lesson, this.lessonHref(), additional_link_classes);
                    duration_container.append(lesson);
                }

                if ( this.displayActivityBook() ) {
                    let activity_book = this.extras_link(constants.activity_book, this.activityBookHref(), additional_link_classes);
                    duration_container.append(activity_book);
                }

                if ( this.displayQuiz() ) {
                    let quiz = this.extras_link(constants.quiz_game, this.quizHref(), additional_link_classes);
                    duration_container.append(quiz);
                }
            }
        }

        return this.clone;
    }

    screenshot() {
        if ( this.object['screenshot'] ) {
            return this.object['screenshot'];
        }

        return null;
    }

    name() {
        if ( this.object['episode_number'] && this.object['name'] ) {
            return this.object['episode_number'] + '. ' + this.object['name'];
        }

        return null;
    }

    description() {
        return this.object['description'];
    }

    duration() {
        if ( this.object['duration'] ) {
            let duration_hours_minutes = formatDurationToHoursAndMinutes( this.object['duration'] );
            return '(' + duration_hours_minutes + ')';
        }

        return null;
    }

    progress() {
        let progress = new ProgressBar( this.object['duration'], this.object['resume_time'] );
        return progress.element();
    }

    extras_link(text, href,additional_classes=[]) {
        let object_link = document.createElement("a");
        object_link.href = href;
        object_link.innerHTML = text;

        for(let i in additional_classes) {
            if ( additional_classes[i] ) {
                object_link.classList.add(additional_classes[i]);
            }
        }

        object_link.target = '_blank';

        return object_link;
    }

    displayExtras() {
        return this.displayQuiz() || this.displayLesson() || this.displayActivityBook();
    }

    displayQuiz() {
        return this.object['quiz'] === true;
    }

    displayLesson() {
        return this.object['lesson'] && this.object['lesson']['display'] === true && this.lessonHref() && !this.lessonHref().includes('original/missing');
    }

    displayActivityBook() {
        let url = this.object['storybook_pdf.expiring_url'];
        return url && !url.includes('original/missing');
    }

    activityBookHref() {
        return this.object['storybook_pdf.expiring_url'];
    }

    lessonHref() {
        return this.object['lesson_pdf.expiring_url'];
    }

    quizHref() {
        return this.pathToMovie(this.constants.path.quiz);
    }

    pathToMovie(path) {
        return path.replace( ':slug', this.slug() );
    }

    slug() {
        return this.object['slug'];
    }
}